import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import GroupAdminHeader from "../../../../Comman/Header";
import GroupAdminSidebar from "../../../../Comman/Sidebar";
import GroupAdminUperSide from "../../../../Comman/UperSide";
import headers from "../../../../../CommonApi/headers";
import api from "../../../../../CommonApi/axios";
import useDrawer from "../../../../../context/DrawerContext";
import { MenuPermissions, userPermissionType } from "../../../../Comman/UserPermission";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { tableOptionMenuProducts } from "../../../../NewTableCommon/tableOption";
import useWindowHeight from "../../../../NewTableCommon/useWindowsPosition";
import renderStatusChip from "../../../../NewTableCommon/renderStatusChip";
import ColumPopoverCommon from "../../../../NewTableCommon/ColumPopoverCommon";

export default function GroupAdminMenuCategory() {
  let history = useHistory();
  const location = useLocation();

  var pathname = window.location.pathname;
  var pathnamesplits = pathname.split("/");
  var url = pathnamesplits[3];

  const [error, setError] = useState(null);
  const [user, setuser] = useState([]);
  const [anchorEl_, setAnchorEl_] = useState(null);
  const [updateColumns, setUpdateColumns] = useState(false);

  const { drawerPos, handleDrawer, maingetViewDetails } = useDrawer();

  const ColumnsDataString = sessionStorage.getItem(`${url}_columnData`);
  const columnsData = ColumnsDataString ? JSON.parse(ColumnsDataString) : null;
  const DisplayCol = columnsData && Object.values(columnsData).includes(false);
  const windowHeight = useWindowHeight();

  const groupAdminCategoryListById = useCallback(() => {
    let data = JSON.stringify({ menu_id: location.state.menuId });
    api
      .post(`/groupadmin/category/${location.state.branchID}`, data, {
        headers: headers,
      })
      .then((res) => {
        const tableData = res.data.data;
        setuser(tableData);
      })
      .catch((err) => {
        setError("No Category Found.");
      });
  }, [location.state.menuId, location.state.branchID]);

  useEffect(() => {
    groupAdminCategoryListById();
  }, [groupAdminCategoryListById]);

  const EditCatagory = useCallback(
    (_id) => {
      history.push(
        `/group_admin/menu_management/category/edit_menu_category/${_id}/${location.state.menuId}/${location.state.branchID}`
      );
    },
    [history, location.state.menuId, location.state.branchID]
  );

  const handleFilterClick = () => {};
  const handleClickColum_ = (event) => {
    setAnchorEl_(event.currentTarget);
  };
  const handleCloseColum_ = () => {
    setAnchorEl_(null);
  };
  const onColumnDataChange = () => {
    setUpdateColumns((prevState) => !prevState);
  };

  const Columns = useMemo(() => {
    const updateTrigger = updateColumns;
    if (updateTrigger) {
      // trigger update when column visibility changes
    }
    const columns = [
      {
        accessorKey: 'srNo',
        header: 'Sr.No',
        size: 100,
        Cell: ({ row }) => row.index + 1,
      },
      {
        accessorKey: 'name_EN',
        header: 'Category Name',
        size: 300,
        Cell: ({ row }) => (
          <Link
            to={{
              pathname: `/group_admin/menu_management/category/edit_menu_category/${row?.original?._id}/${location.state.menuId}/${location.state.branchID}`,
              state: { 
                menuId: location.state.menuId, 
                branchID: location.state.branchID 
              }
            }}
            style={{ 
              fontWeight: 'bold', 
              color: '#F25042', 
              textDecoration: 'none', 
              cursor: 'pointer' 
            }}
            onMouseEnter={(e) => e.target.style.color = '#b91c1c'}
            onMouseLeave={(e) => e.target.style.color = '#dc2626'}
          >
            {row?.original?.name_EN || '---'}
          </Link>
        ),
      },
      {
        accessorKey: 'printer_text',
        header: 'Printer',
        size: 250,
        Cell: ({ row }) => row?.original?.printer_text || '---',
      },
      {
        accessorKey: 'seq_no',
        header: 'Sequence No',
        size: 200,
        Cell: ({ row }) => row?.original?.seq_no,
      },
      {
        accessorKey: 'is_active',
        header: 'Status',
        size: 200,
        Cell: ({ row }) => renderStatusChip(row?.original?.is_active),
      },
    ];
    return columnsData === null
      ? columns
      : columns.filter((column) => columnsData[column.header] === true);
  }, [updateColumns, columnsData, EditCatagory]);

  const filteredCategoryList = user;

  const table = useMaterialReactTable({
    columns: Columns,
    data: filteredCategoryList,
    ...tableOptionMenuProducts({
      getMenuList: groupAdminCategoryListById,
      url23: url,
      handleClickColum_,
      handleFilterClick,
      windowHeight,
      filterData: null,
      DisplayCol,
    }),
  });

  return (
    <React.Fragment>
      <div
        id="kt_body"
        className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
      >
        <div className="d-flex flex-column flex-root">
          <div className="page d-flex flex-row flex-column-fluid">
            <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer} />
            <div
              className="wrapper d-flex flex-column flex-row-fluid"
              id="kt_wrapper"
            >
              <GroupAdminHeader />
              <div
                className="d-flex flex-column flex-column-fluid"
                id="kt_content"
              >
                <div id="kt_content_container" className="mx-7">
                  <main className={`main_ ${maingetViewDetails.join(" ")}`}>
                    <h1
                      className="anchor fw-bolder mb-5"
                      id="vertical-horizontal-scroll"
                    >
                      Menu Management
                    </h1>
                    <hr />

                    <div className="d-flex flex-stack mb-5">
                      <div
                        className="d-flex justify-content-end"
                        data-kt-docs-table-toolbar="base"
                      >
                        <h2
                          className="anchor fw-bolder mb-5"
                          id="custom-form-control"
                        >
                          Category
                        </h2>
                      </div>
                      <div className="d-flex flex-stack mb-5">
                        <div
                          className="d-flex justify-content-end mx-2"
                          data-kt-docs-table-toolbar="base"
                        >
                          {(userPermissionType === "groupadmin" ||
                            MenuPermissions?.access?.includes("create")) && (
                              <Link
                                to={{
                                  pathname:
                                    "/group_admin/menu_management/category/add_new_menu_category",
                                  state: {
                                    menuId: location.state.menuId,
                                    branchID: location.state.branchID,
                                  },
                                }}
                                className="btn btn-primary ps-7"
                              >
                                Add Category
                              </Link>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="rounded border p-5">
                      {/* Tab Navigation */}
                      <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6">
                        <li className="nav-item">
                          <Link
                            className={
                              url === "menu_information"
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to={{
                              pathname:
                                "/group_admin/menu_management/menu_information",
                              state: {
                                menuId: location.state.menuId,
                                branchID: location.state.branchID,
                              },
                            }}
                          >
                            Information
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            className={
                              url === "menu_category"
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to={{
                              pathname:
                                "/group_admin/menu_management/menu_category",
                              state: {
                                menuId: location.state.menuId,
                                branchID: location.state.branchID,
                              },
                            }}
                          >
                            Categories
                          </Link>
                        </li>
                      </ul>

                      {/* Tab Content */}
                      <div className="tab-content" id="myTabContent">
                        <div
                          className="tab-pane fade show active"
                          id="kt_tab_pane_1"
                          role="tabpanel"
                        >
                          <div className="card card-docs mb-2">
                            <div className="card-body fs-6 py-15 px-10 px-lg-15 text-gray-700">
                              {user && user.length > 0 ? (
                                <div className="table-responsive">
                                  <MaterialReactTable table={table} />
                                </div>
                              ) : (
                                <div className="text-center py-10">
                                  <b style={{ color: "#000000", fontSize: "20px" }}>
                                    {error ? error : "No categories found."}
                                  </b>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </main>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ColumPopoverCommon
          anchorEl_={anchorEl_}
          handleClickColum_={handleClickColum_}
          onColumnDataChange={onColumnDataChange}
          handleCloseColum_={handleCloseColum_}
          url23={url}
        />
        <GroupAdminUperSide />
      </div>
    </React.Fragment>
  );
}